<template>
  <v-form ref="form" lazy-validation>
    <v-row dense>
      <v-col cols="12" sm="4">
        <v-text-field
          :value="value.transaction_id"
          label="Transaction ID*"
          outlined
          dense
          :disabled="readonly"
          :rules="readonly ? [] : [rules.required]"
          @input="update('transaction_id', $event)"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <v-menu
          v-model="dateMenu"
          :disabled="readonly"
          :close-on-content-click="false"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="formatDateDisplay(value.transaction_date)"
              label="Transaction Date*"
              outlined
              dense
              readonly
              :disabled="readonly"
              :rules="readonly ? [] : [rules.required]"
              placeholder="dd-mm-yyyy"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            :value="value.transaction_date"
            @input="updateDate"
            @change="dateMenu = false"
          />
        </v-menu>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          :value="value.bank_name"
          label="Bank Name"
          outlined
          dense
          :disabled="readonly"
          @input="update('bank_name', $event)"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          :value="value.bank_account_number"
          label="Account Number"
          outlined
          dense
          :disabled="readonly"
          @input="update('bank_account_number', $event)"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <v-select
          :value="value.payment_mode"
          :items="paymentModes"
          label="Payment Mode"
          outlined
          dense
          :disabled="readonly"
          @change="update('payment_mode', $event)"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12">
        <v-textarea
          :value="value.remarks"
          label="Remarks (Optional)"
          outlined
          dense
          rows="1"
          :disabled="readonly"
          @input="update('remarks', $event)"
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { rules } from "@/helpers/rules";
import { PAYMENT_MODES } from "./transaction";

export default {
  name: "RevenueSplitTransactionDetailsForm",

  props: {
    value: { type: Object, required: true },
    // View-only mode: the period is already finalized, so nothing is editable.
    readonly: { type: Boolean, default: false },
  },

  data() {
    return { rules, paymentModes: PAYMENT_MODES, dateMenu: false };
  },

  methods: {
    update(field, fieldValue) {
      this.$emit("input", { ...this.value, [field]: fieldValue });
    },

    updateDate(date) {
      this.update("transaction_date", date);
    },

    formatDateDisplay(date) {
      if (!date) return "";
      // Parse date string (format: YYYY-MM-DD or ISO)
      const d = new Date(date);
      if (isNaN(d.getTime())) return "";
      // Format as dd-mm-yyyy
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    },

    // Parent calls this before advancing so the red validation state shows.
    validate() {
      return this.$refs.form.validate();
    },
    reset() {
      this.$refs.form?.resetValidation();
    },
  },
};
</script>
